import React from 'react';
import { motion } from 'framer-motion';
interface FractionVisualProps {
  value: number; // 0.25 = 1/4, 0.5 = 1/2, etc.
  label?: string;
  type?: 'circle' | 'bar';
}
export function FractionVisual({
  value,
  label,
  type = 'circle'
}: FractionVisualProps) {
  if (type === 'bar') {
    return <div className="bg-slate-50 p-6 rounded-xl border border-slate-100" data-id="element-1279">
        {label && <div className="text-sm font-medium text-slate-700 mb-3 text-center" data-id="element-1280">
            {label}
          </div>}
        <div className="relative h-12 bg-slate-200 rounded-lg overflow-hidden" data-id="element-1281">
          <motion.div initial={{
          width: 0
        }} animate={{
          width: `${value * 100}%`
        }} transition={{
          duration: 0.8,
          ease: 'easeOut'
        }} className="absolute inset-y-0 left-0 bg-indigo-500 rounded-lg" data-id="element-1282" />
          <div className="absolute inset-0 flex items-center justify-center text-sm font-bold text-slate-700" data-id="element-1283">
            {Math.round(value * 100)}%
          </div>
        </div>
      </div>;
  }
  // Circle (pie chart)
  const radius = 60;
  const circumference = 2 * Math.PI * radius;
  const strokeDashoffset = circumference * (1 - value);
  return <div className="bg-slate-50 p-6 rounded-xl border border-slate-100" data-id="element-1284">
      {label && <div className="text-sm font-medium text-slate-700 mb-3 text-center" data-id="element-1285">
          {label}
        </div>}
      <div className="flex justify-center" data-id="element-1286">
        <svg width="140" height="140" className="transform -rotate-90" data-id="element-1287">
          {/* Background circle */}
          <circle cx="70" cy="70" r={radius} fill="none" stroke="rgb(226, 232, 240)" strokeWidth="20" data-id="element-1288" />
          {/* Filled portion */}
          <motion.circle cx="70" cy="70" r={radius} fill="none" stroke="rgb(99, 102, 241)" strokeWidth="20" strokeDasharray={circumference} initial={{
          strokeDashoffset: circumference
        }} animate={{
          strokeDashoffset
        }} transition={{
          duration: 0.8,
          ease: 'easeOut'
        }} strokeLinecap="round" data-id="element-1289" />
          {/* Center text */}
          <text x="70" y="70" textAnchor="middle" dy="0.3em" className="text-2xl font-bold fill-slate-700" transform="rotate(90 70 70)" data-id="element-1290">
            {Math.round(value * 100)}%
          </text>
        </svg>
      </div>
    </div>;
}